import React from 'react'
import SingUpForm from '../components/SignUp'

const SingUp = () => {
  return (
<div>
    <SingUpForm/>
</div>
  )
}

export default SingUp